module.exports = __webpack_public_path__ + "static/tires-cta-banner-48e6a21840f54456cb429da022200fc6.jpg";